module.exports = __webpack_public_path__ + "video.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/video.svg
// module id = 368
// module chunks = 0